import React, { useState } from "react";
import styled from "styled-components";
import {
  PrimaryButton,
  SecondaryButton,
  ButtonSizeOptions
} from "@loanbossinc/component-library";
import { Checkbox } from "@material-ui/core";
import DateTimePicker from "material-ui-pickers/DateTimePicker";

const Root = styled.div`
  font-family: Work Sans;
  height: 100%;
  display: flex;
`;

const Body = styled.div`
  font-family: Work Sans;
  font-size: 14px;
  color: #000000;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  font-family: Work Sans;
`;

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: Work Sans;
`;

export const Schedule = props => {
  const [hasReminder, setHasReminder] = useState(false);
  const [datetime, setDatetime] = useState();

  const { onCancel, onSchedule } = props;

  const scheduleCampaign = () => {
    onSchedule();
  };

  return (
    <Root>
      <Container>
        <DateTimePicker
          value={datetime}
          onChange={newValue => {
            setDatetime(newValue);
          }}
        />
      </Container>
      <Container>
        <Body>
          <Checkbox
            checked={hasReminder}
            onClick={() => {
              setHasReminder(!hasReminder);
            }}
          />
          {" "}
          <span>Add a reminder that this campaign will be sent</span>
        </Body>
        <Footer>
          <SecondaryButton
            label="Cancel"
            size={ButtonSizeOptions.smFluid}
            style={{ marginRight: 16, width: 132 }}
            onClick={onCancel}
          />
          <PrimaryButton
            label="Schedule"
            size={ButtonSizeOptions.smFluid}
            onClick={scheduleCampaign}
            style={{ width: 132 }}
          />
        </Footer>
      </Container>
    </Root>
  );
};

export default Schedule;
